import React from "react";
import {
  Box,
  Checkbox,
  ClickAwayListener,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DropDownButton from "../../../Subcomponents/DropDownButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import TreeviewCheckbox from "../../TreeviewCheckbox";
import { getProjectList, getWingList } from "../../../Services/Payments";
import { useState } from "react";
import { useEffect } from "react";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import _, { debounce, findIndex, orderBy } from "lodash";
import { getFilterNames } from "../../../Services/AllAllotments";
import Button from "../../../Subcomponents/Button";
import cssClasses from "../AllAllotments.module.css";
import SearchBar from "../../../Subcomponents/Search";
import DateComponent from "../../../Subcomponents/DateComponent";

const AllotmentFilter = ({
  setAllCrmAllotments,
  getCrmAllotmentsFromServer,
  isTagPendingTab = false,
  pageNumber,
  checked,
  setChecked,
  selectDates,
  setSelectDates,
  hasMore,
  depStr,
  setDepQuery,
  isApprovalPendingTab = false,
  isAgreementTab = false,
  isCancellationTab = false
}) => {
  const [btnName, setBtnName] = useState("None");
  const [filterOpen, setFilterOpen] = useState(false);
  const [projectStr, setProjectStr] = useState({ p: [], w: [], f: [] });
  const [projectSelected, setProjectSelected] = useState([]);
  const [search, setSearch] = useState();
  const [showProjectList, setShowProjectList] = useState(false);
  const [cp, setCp] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("");
  const [salesRepresentative, setSalesRepresentative] = useState([]);
  const [crmUser, setCrmUser] = useState([]);
  const [filterNames, setFilterNames] = useState([]);
  const [filterCheck, setFilterCheck] = useState(0);
  const [projectList, setProjectList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedDates, setSelectedDate] = useState(null);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [filterObj, setFilterObj] = useState([
    {
      id: 0,
      label: "None",
      value: "None",
    },
    {
      id: 1,
      label: "Date",
      value: "Date",
    },
    {
      id: 2,
      label: "CP",
      value: "CP",
      selected: false,
    },
    {
      id: 3,
      label: "SM",
      value: "Users",
      selected: false,
    },
    {
      id: 4,
      label: "CRM",
      value: "CrmUsers",
      selected: false,
    },
    {
      id: 5,
      label: "Projects",
      value: "Projects",
      selected: false,
    },
    (isCancellationTab) && {
      id: 6,
      label: "Status",
      value: "Status",
      selected: false,
    },
    {
      id: 7,
      label: "SDR",
      value: "SDR",
      selected: false,
    },
    !isTagPendingTab && {
      id: 8,
      label: "Email",
      value: "Email",
      selected: false,
    },
    !isTagPendingTab &&{
      id: 9,
      label: "OCR",
      value: "OCR",
      selected: false,
    },
    (!isTagPendingTab && !isApprovalPendingTab && !isCancellationTab) &&{
      id: 10,
      label: "AV",
      value: "AV",
      selected: false,
    },
    (!isTagPendingTab && !isApprovalPendingTab && !isCancellationTab) && {
      id: 11,
      label: "Agreement KYC",
      value: "Agreement KYC",
      selected: false,
    },
    isAgreementTab && {
      id: 12,
      label: "Agreement Status",
      value: "Agreement Status",
      selected: false,
    },
    isAgreementTab && {
      id: 13,
      label: "Draft",
      value: "Draft",
      selected: false,
    },
    isAgreementTab && {
        id: 14,
        label: "Emandate",
        value: "Emandate",
        selected: false,
    },
  ].filter(Boolean) 
);

  // useEffect(() => {
  //   getCrmAllotmentsFromServer();
  // }, [checked]);

  useEffect(() => {
    setDepQuery(depStr + search);
  }, [search]);

  useEffect(() => {
    if (btnName === "None") {
      getCrmAllotmentsFromServer();
    }
  }, [btnName]);

  useEffect(() => {
    if (filter == "CP") {
      setFilterNames(cp);
    } else if (filter == "Projects") {
      setFilterNames(projects);
    } else if (filter == "Users") {
      setFilterNames(salesRepresentative);
    } else if (filter == "CrmUsers") {
      setFilterNames(crmUser);
    } else if (filter == "Date") {
      setFilterNames([]);
    } else if (filter == "Status") {
      setFilterNames([
        {
          filter: "Status",
          name: "Cancellation Requested",
          id: "Cancellation Requested",
        },

        {
          filter: "Status",
          name: "Cancellation Pending",
          id: "Cancellation Pending",
        },
        {
          filter: "Status",
          name: "Cancellation Rejected",
          id: "Cancellation Rejected",
        },
        {
          filter: "Status",
          name: "Cancellation Done",
          id: "Cancellation Done",
        },
        {
          filter: "Status",
          name: "Cancellation Not Done",
          id: "Cancellation Not Done",
        },
        { filter: "Status", name: "Cancelled", id: "Cancelled" },
      ]);
    } else if (filter == "SDR") {
      setFilterNames([
        { filter: "SDR", name: "SDR Pending", id: "SDR Pending" },
        { filter: "SDR", name: "SDR Complete", id: "SDR Complete" },
      ]);
    }else if (filter == "OCR") {
      setFilterNames([
        { filter: "OCR", name: "Less than 10%", id: "Less than 10%" },
        { filter: "OCR", name: "Equals to 10%", id: "Equals to 10%" },
        { filter: "OCR", name: "Greater than 10%", id: "Greater than 10%" },
      ]);
    } else if (filter == "Email") {
      setFilterNames([
        { filter: "Email", name: "Email Sent", id: "Email Sent" },
        { filter: "Email", name: "Email Not Sent", id: "Email Not Sent" },
      ]);
    } else if (filter === "AV") {
      setFilterNames([
        { filter: "AV", name: "AV Changed", id: "AV Changed" },
        { filter: "AV", name: "AV Not Changed", id: "AV Not Changed" },
      ]);
    } else if (filter === "Agreement KYC") {
      setFilterNames([
        { filter: "Agreement KYC", name: "Agreement KYC Done", id: "Agreement KYC Done" },
        { filter: "Agreement KYC", name: "Agreement KYC Pending", id: "Agreement KYC Pending" },
      ]);
    } else if (filter === "Agreement Status") {
      setFilterNames([
        { filter: "Agreement Status", name: "Agreement Pending", id: "Agreement Pending" },
        { filter: "Agreement Status", name: "Agreement Done", id: "Agreement Done" },
      ]);
    }else if (filter === "Draft") {
      setFilterNames([
        { filter: "Draft", name: "Create Draft Agreement", id: "Create Draft Agreement" },
        { filter: "Draft", name: "Preview Agreement", id: "Preview Agreement" },
      ]);
    } else if (filter == "Emandate") {
      setFilterNames([
        {
          filter: "Emandate",
          name: "Pending",
          id: "Pending",
        },
        {
          filter: "Emandate",
          name: "Partial",
          id: "Partial",
        },
        {
          filter: "Emandate",
          name: "Completed",
          id: "Completed",
        },
      ]);
    }
  }, [filterObj, filter]);
  useEffect(() => {
    let all_filters = [];

    let all_cpId = [];
    let all_projectId = [];
    let all_salesRepresentativeId = [];
    let all_status = [];
    let all_crmUsers = [];
    let all_sdr = [];
    let all_email = [];
    let all_ocr = [];
    let all_av = [];
    let all_agreement_kyc = [];
    let all_agreement_status = [];
    let draft = [];
    let jsonParse;
    let all_emandate_status = [];

    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsers.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "SDR") {
        all_sdr.push(jsonParse.value);
      }else if (jsonParse.filter == "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter == "AV") {
        all_av.push(jsonParse.value);
      } else if(jsonParse.filter == "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if(jsonParse.filter === "Agreement Status"){
        all_agreement_status.push(jsonParse.value);
      }else if(jsonParse.filter === "Draft"){
        draft.push(jsonParse.value);
      }else if (jsonParse.filter == "Emandate") {
        all_emandate_status.push(jsonParse.value);
      }
    });

    if (all_cpId.length !== 0) {
      if (all_filters.indexOf("CP") == -1) {
        all_filters.push("CP");
      }
    }

    if (all_status.length !== 0) {
      if (all_filters.indexOf("Status") == -1) {
        all_filters.push("Status");
      }
    }

    if (all_sdr.length !== 0) {
      if (all_filters.indexOf("SDR") == -1) {
        all_filters.push("SDR");
      }
    }

    if (all_ocr.length !== 0) {
      if (all_filters.indexOf("OCR") == -1) {
        all_filters.push("OCR");
      }
    }

    if (all_email.length !== 0) {
      if (all_filters.indexOf("Email") == -1) {
        all_filters.push("Email");
      }
    }
    
    if (all_av.length !== 0) {
      if (all_filters.indexOf("AV") == -1) {
        all_filters.push("AV");
      }
    }

    if(all_agreement_kyc.length !== 0) {
      if(all_filters.indexOf("Agreement KYC") == -1){
        all_filters.push("Agreement KYC");
      }
    }

    if(all_agreement_status.length !== 0) {
      if(all_filters.indexOf("Agreement Status") == -1){
        all_filters.push("Agreement Status");
      }
    }
    if(draft.length !== 0) {
      if(all_filters.indexOf("Draft") == -1){
        all_filters.push("Draft");
      }
    }

    if (
      all_projectId[0]?.[0]?.["p"]?.length > 0 ||
      all_projectId[0]?.[0]?.["w"]?.length > 0 ||
      all_projectId[0]?.[0]?.["f"]?.length > 0
    ) {
      if (all_filters.indexOf("Projects") == -1) {
        all_filters.push("Projects");
      }
    }

    if (all_salesRepresentativeId.length !== 0) {
      if (all_filters.indexOf("SM") == -1) {
        all_filters.push("SM");
      }
    }

    if (selectDates[0]?.value !== "" && selectDates[1]?.value !== "") {
      if (all_filters.indexOf("Date") == -1) {
        all_filters.push("Date");
      }
    }

    if (all_crmUsers.length !== 0) {
      if (all_filters.indexOf("CRM") == -1) {
        all_filters.push("CRM");
      }
    }
    // if (projectSelected.length !== 0) {
    //   all_filters.push("Project");
    // }
    if (all_av.length !== 0) {
      if (all_filters.indexOf("AV") == -1) {
        all_filters.push("AV");
      }
    }
    
    if (all_emandate_status.length !== 0) {
      if (all_filters.indexOf("Emandate") == -1) {
        all_filters.push("Emandate");
      }
    }

    if (all_filters.length == 0) {
      setBtnName("None");
    } else {
      setBtnName(all_filters.join(","));
    }
  }, [checked, selectDates]);

  useEffect(() => {
    if (filter === "None") {
      setSelectDates([
        { label: "StartDate", value: "" },
        { label: "EndDate", value: "" },
      ]);
    }
  }, [filter]);

  useEffect(() => {
    // getProjectList();

    const fetchEvents = async () => {
      const data = await getProjectList();
      setProjectList(data);
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    if (filter === "CP") {
      setFilterNames(
        cp.filter((f) =>
          searchValue
            ? f?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Users") {
      setFilterNames(
        salesRepresentative.filter((f) =>
          searchValue
            ? f?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "CrmUsers") {
      setFilterNames(
        crmUser.filter((f) =>
          searchValue
            ? f?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Projects") {
      if (searchValue !== "") {
        setProjectList(
          projectList.filter((f) =>
            searchValue
              ? f?.label?.toLowerCase()?.includes(searchValue?.toLowerCase())
              : true
          )
        );
      } else {
        const fetchEvents = async () => {
          const data = await getProjectList();
          setProjectList(data);
        };
        fetchEvents();
      }
    }
  }, [searchValue]);

  const handleToggle = (value, filter) => () => {
    const currentIndex = checked.indexOf(
      JSON.stringify({ value: value, filter: filter })
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(JSON.stringify({ value: value, filter: filter }));
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleFilterApply = async () => {
    setAllCrmAllotments([]);
    pageNumber.current = 0;
    hasMore.current = true;
    if (checked) {
      presentLoader();
      getCrmAllotmentsFromServer(true);

      setFilterOpen(false);
      dismissLoader();
    }
    setDepQuery(
      filter +
        JSON.stringify(checked) +
        JSON.stringify(projectStr) +
        Math.random(0, 1)
    );
  };

  const handleFilterClose = (isClear = false) => {
    if (filterOpen) {
      isClear && setProjectSelected([]);
      isClear && setProjectStr({ p: [], w: [], f: [] });
      isClear && setChecked([]);
      isClear &&
        setSelectDates([
          { label: "StartDate", value: "" },
          { label: "EndDate", value: "" },
        ]);
      isClear && getSubfilters("None", 0);
      setFilterOpen(false);
      isClear && setDepQuery(depStr + 1);
      isClear && getCrmAllotmentsFromServer(false, true);
    } else {
      setFilterOpen(true);
    }

    // setChecked([]);
  };

  async function getSubfilters(value, filterId) {
    let CP_Items = [];
    let Project_Items = [];

    if (value !== "Projects") {
      setShowProjectList(false);
    }
    if (value == "CP") {
      if (!cp[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          CP_Items.push({
            id: item.cpId,
            name: item.billingName,
            filter: value,
          });
        });
        const sortedCp = orderBy(
          CP_Items,
          [(cp) => cp.name.toLowerCase()],
          ["asc"]
        );
        setCp(sortedCp);
        setFilterNames(sortedCp);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projectList[0]) {
        const data = await getProjectList();
        setProjectList(data);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projects[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          Project_Items.push({
            id: item.projectId,
            name: item.projectName,
            filter: value,
          });
        });
        const sortedProjects = orderBy(
          Project_Items,
          [(project) => project.name.toLowerCase()],
          ["asc"]
        );
        setProjects(sortedProjects);
      }
      setFilter(value);
    } else if (value == "Users") {
      if (!salesRepresentative[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          (item?.isCrmUser === null || item?.isCrmUser === false) &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setSalesRepresentative(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "CrmUsers") {
      if (!crmUser[0]) {
        presentLoader();
        const { data } = await getFilterNames("Users");
        dismissLoader();
        data.map((item) => {
          item?.isCrmUser === true &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setCrmUser(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "priceRange") {
      setFilter(value);
    } else if (value == "Date") {
      setFilter(value);
    } else if (value == "Status") {
      setFilter(value);
      setFilterNames([
        { filter: "Status", name: "Payment Complete", id: "Payment Complete" },
        {
          filter: "Status",
          name: "Cancellation Requested",
          id: "Cancellation Requested",
        },

        {
          filter: "Status",
          name: "Cancellation Pending",
          id: "Cancellation Pending",
        },
        {
          filter: "Status",
          name: "Cancellation Rejected",
          id: "Cancellation Rejected",
        },
        {
          filter: "Status",
          name: "Cancellation Done",
          id: "Cancellation Done",
        },
        {
          filter: "Status",
          name: "Cancellation Not Done",
          id: "Cancellation Not Done",
        },
        { filter: "Status", name: "Cancelled", id: "Cancelled" },
        { filter: "Status", name: "Agreement Done", id: "Agreement Done" },
      ]);
    } else if (value == "SDR") {
      setFilter(value);
      setFilterNames([
        { filter: "SDR", name: "SDR Pending", id: "SDR Pending" },
        { filter: "SDR", name: "SDR Complete", id: "SDR Complete" },
      ]);
    }else if (value == "OCR") {
      setFilter(value);
      setFilterNames([
        { filter: "OCR", name: "Less than 10%", id: "Less than 10%" },
        { filter: "OCR", name: "Equals to 10%", id: "Equals to 10%" },
        { filter: "OCR", name: "Greater than 10%", id: "Greater than 10%" },
      ]);
    } else if (value == "Email") {
      setFilter(value);
      setFilterNames([
        { filter: "Email", name: "Email Sent", id: "Email Sent" },
        { filter: "Email", name: "Email Not Sent", id: "Email Not Sent" },
      ]);
    } else if (value === "AV") {
      setFilter(value);
      setFilterNames([
        { filter: "AV", name: "AV Changed", id: "AV Changed" },
        { filter: "AV", name: "AV Not Changed", id: "AV Not Changed" },
      ]);
    } else if (value === "Agreement KYC") {
      setFilter(value);
      setFilterNames([
        { filter: "Agreement KYC", name: "Agreement KYC Done", id: "Agreement KYC Done" },
        { filter: "Agreement KYC", name: "Agreement KYC Pending", id: "Agreement KYC Pending" },
      ]);
    } else if (value === "Agreement Status") {
      setFilter(value);
      setFilterNames([
        { filter: "Agreement Status", name: "Agreement Pending", id: "Agreement Pending" },
        { filter: "Agreement Status", name: "Agreement Done", id: "Agreement Done" },
      ]);
    }else if (value === "Draft") {
      setFilter(value);
      setFilterNames([
        { filter: "Draft", name: "Create Draft Agreement", id: "Create Draft Agreement" },
        { filter: "Draft", name: "Preview Agreement", id: "Preview Agreement" },
      ]);
    } else if (value == "Emandate") {
      setFilter(value);
      setFilterNames([
        {
          filter: "Emandate",
          name: "Pending",
          id: "Pending",
        },
         {
          filter: "Emandate",
          name: "Partial",
          id: "Partial",
        },
        {
          filter: "Emandate",
          name: "Completed",
          id: "Completed",
        },
      ]);
    } else {
      setFilterNames([]);
      setCp([]);
      setSalesRepresentative([]);
      setCrmUser([]);
      setChecked([]);
      setProjects([]);
      setProjectList([]);

      setFilter("None");
    }

    setFilterCheck(filterId);
  }

  const debouncedFetchSearchData = debounce((e) => {
    // searchValue.current = e.target.value;
    setSearchValue(e.target.value);
    // if(searchValue.current) {

    // } else {
    //   allCrmAllotments
    // }
  }, 500);

  const handleFetchChild = (id) => {
    const fetchEvents = async () => {
      const data = await getWingList(id);
      const finalPayload = [...projectList];
      const index = finalPayload.findIndex((i) => i.id === id);
      finalPayload.splice(index, 1, data[0]);
      setProjectList(finalPayload);
    };
    fetchEvents();
  };

  return (
    <div
      className={cssClasses.filterWrapper}
      style={{ flexDirection: "row", gap: "10px" }}
    >
      <div className={cssClasses.label}>
        <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Filter by</p>
      </div>
      <ClickAwayListener
        onClickAway={() => {
          setFilterOpen(false);
        }}
      >
        <div
          className={cssClasses.dropdownWrapper}
          style={{ minWidth: "120px" }}
        >
          <DropDownButton
            style={{
              color: "#323232",
              backgroundColor: "#fff",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Inter-Medium !important",
              height: "34px",
            }}
            btnTextStyle={{width:"130px"}}
            btnName={btnName}
            // outline={true}
            clicked={() => handleFilterClose(false)}
            btnIcon={
              <ExpandMoreIcon style={{ width: "15px", height: "15px" }} />
            }
            iconPosition={"right"}
          />

          <div
            className={cssClasses.filterModalWrapper}
            style={{ display: filterOpen ? "block" : "none" }}
          >
            <div className={cssClasses.filterModalChild}>
              <div style={{ width: "50%" }}>
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "background.paper",
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  {filterObj.map((item) => {
                    return (
                      <ListItem
                        style={{ padding: "0" }}
                        onClick={() => {
                          getSubfilters(item.value, item.id);
                        }}
                      >
                        <ListItemButton>
                          <ListItemText primary={item.label} />
                          {filterCheck == item.id ? (
                            <ListItemIcon style={{ minWidth: "auto" }}>
                              <CheckIcon fontSize="large" color="primary" />
                            </ListItemIcon>
                          ) : (
                            ""
                          )}
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </div>

              <div
                style={{
                  padding: "0 6px",
                  width: "75%",
                  backgroundColor: "#F9FAFB",
                  borderRadius: "8px",
                  height: "390px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {showProjectList ? (
                  <Box mt={1}>
                    {filter === "Projects" && (
                      <div>
                        <SearchBar
                          placeholder={"Search "}
                          search={debouncedFetchSearchData}
                          id={"tagPendingCrmAllotmentLeadName"}
                        />
                      </div>
                    )}
                    {projectList?.length === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          top: "70%",
                          height: "325px",
                          fontSize: "1.5rem",
                          alignItems: "center",
                        }}
                      >
                        No Data Available
                      </div>
                    ) : (
                      <TreeviewCheckbox
                        data={projectList}
                        isChildFetch
                        handleFetchChildren={(t) => {
                          handleFetchChild(t);
                        }}
                        selectedCheckboxes={projectSelected}
                        onSelectCheckbox={setProjectSelected}
                        onChange={(str) => {
                          setProjectStr(str);
                          setChecked((prev) => [
                            ...prev.filter((item) => {
                              prev = JSON.parse(item);
                              return prev.filter !== "Projects";
                            }),
                            JSON.stringify({
                              value: [str],
                              filter: "Projects",
                            }),
                          ]);
                        }}
                      />
                    )}
                  </Box>
                ) : (
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.#F9FAFB",
                      overflowY: "auto",
                      overflowX: "hidden",
                      // height: "250px",
                    }}
                  >
                    {" "}
                    {filter === "Date" ? (
                      <div>
                        <div className={cssClasses.dateDivider}>
                          <div className={cssClasses.label}>Start Date</div>
                          <DateComponent
                            value={selectDates[0].value}
                            minDate={"1 Jan"}
                            maxDate={new Date()}
                            onChangeDate={(value) => {
                              setSelectedDate("notNull");
                              setSelectDates((pre) => {
                                pre[0].value = value;
                                return { ...pre };
                              });
                              setHelperText((pre) => {
                                pre.endDate = "";
                                return { ...pre };
                              });
                            }}
                            helperText={helperText.startDate}
                          ></DateComponent>
                        </div>
                        <div>
                          <div className={cssClasses.label}>End Date</div>
                          <DateComponent
                            value={selectDates[1].value}
                            isClassName
                            minDate={"1 Jan"}
                            onChangeDate={(value) => {
                              setSelectedDate("notNull");
                              if (selectDates[0].value === "") {
                                setHelperText((pre) => {
                                  pre.endDate =
                                    "Please select start date first";
                                  return { ...pre };
                                });
                              } else {
                                if (selectDates[0].value > value) {
                                  setHelperText((pre) => {
                                    pre.endDate =
                                      "Select End Date Greater than start Date";
                                    return { ...pre };
                                  });
                                } else {
                                  setSelectDates((pre) => {
                                    pre[1].value = value;
                                    return { ...pre };
                                  });
                                  setHelperText((pre) => {
                                    pre.endDate = "";
                                    return { ...pre };
                                  });
                                  let indexOfMainList = findIndex(
                                    filterObj,
                                    ({ label }) => label === "Date"
                                  );
                                  setFilterObj((pre) => {
                                    pre[indexOfMainList].select = true;
                                    return [...pre];
                                  });
                                  if (
                                    selectedListDropDown.find(
                                      (value) => value === "Date"
                                    ) === undefined
                                  ) {
                                    selectedListDropDown.push("Date");
                                  }
                                }
                              }
                            }}
                            helperText={helperText.endDate}
                          ></DateComponent>
                        </div>
                      </div>
                    ) : (
                      ["Users", "CrmUsers", "CP", "Projects"].map((fil) => {
                        return (
                          <div style={{ margin: "5px" }}>
                            {fil === filter && (
                              <SearchBar
                                placeholder={filter}
                                search={debouncedFetchSearchData}
                                id={"tagPendingCrmAllotmentLeadName"}
                              />
                            )}
                          </div>
                        );
                      })
                    )}
                    {filterNames?.length === 0 &&
                    ["Users", "CrmUsers", "CP", "Projects"].includes(filter) ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          top: "70%",
                          height: "325px",
                          fontSize: "1.5rem",
                          alignItems: "center",
                        }}
                      >
                        No Data Available
                      </div>
                    ) : (
                      filterNames.map((item) => {
                        const labelId = `checkbox-list-label-${item.id}`;

                        return (
                          <ListItem
                            key={item.id}
                            // secondaryAction={
                            //     <IconButton edge="end" aria-label="comments">
                            //         <CommentIcon />
                            //     </IconButton>
                            // }
                            disablePadding
                          >
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(item.name, item.filter)}
                              dense
                            >
                              <ListItemIcon style={{ minWidth: "auto" }}>
                                <Checkbox
                                  edge="start"
                                  checked={
                                    checked.indexOf(
                                      JSON.stringify({
                                        value: item.name,
                                        filter: item.filter,
                                      })
                                    ) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={item.name} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })
                    )}
                  </List>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                backgroundColor: "#F9FAFB",
                padding: "12px",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
                borderTop: "1px solid #EAECF0",
                justifyContent: "end",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: "100px",
                  float: "right",
                  marginRight: "12px",
                  backgroundColor: "#F9FAFB",
                }}
              >
                <Button
                  style={{
                    width: "100px",
                    color: "#323232",
                    backgroundColor: "#fff",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    fontFamily: "Inter-Medium !important",

                    // marginLeft: "-12px"
                  }}
                  btnName={"Clear"}
                  // outline={true}
                  clicked={() => handleFilterClose(true)}
                  // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                  iconPosition={"left"}
                />
              </div>
              <div
                style={{
                  width: "100px",
                }}
              >
                <Button
                  style={{
                    color: "#fff",
                    backgroundColor: "#1570EF",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    fontFamily: "Inter-Medium !important",

                    // marginLeft: "-12px"
                  }}
                  btnName={"Apply"}
                  disable={
                    helperText?.startDate !== "" || helperText?.endDate !== ""
                  }
                  // outline={true}
                  clicked={handleFilterApply}
                  // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                  iconPosition={"left"}
                />
              </div>
            </div>
          </div>
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default AllotmentFilter;
